import { render, staticRenderFns } from "./StructureTab.vue?vue&type=template&id=7765891a&scoped=true&"
import script from "./StructureTab.vue?vue&type=script&lang=ts&"
export * from "./StructureTab.vue?vue&type=script&lang=ts&"
import style0 from "./StructureTab.vue?vue&type=style&index=0&id=7765891a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7765891a",
  null
  
)

export default component.exports